module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-980.204c1172.jpg";